dom = function (cui_enabled) {
	//
	var objDom = {};
	var objDialog = dialog();
	var cui_enabled = cui_enabled;

	/*
	 * Function: verticalStretchList
	 * Purpose: Stretches the interface down with snapping.
	 */
	objDom.verticalStretchList = function (minHeight) {
		var minHeight = minHeight;
		if (cui_enabled) {
			return;
		}
		if (minHeight === undefined) {
			minHeight = 800;
		}

		var columnSelectors = [
			'#curriculog-summary-column',
			'#curriculog-summary-column .summary.active',
			'#curriculog-list-column-results',
			'#curriculog-dashboard-column',
			'#curriculog-send-message-column',
			'#curriculog-hierarchy-column',
			'#curriculog-types-column',
			'#curriculog-import-required-column',
		];

		var elements = $(columnSelectors.join(','));
		var heights = [];
		elements.each(function() {
			if ($(this).attr('id') == 'curriculog-import-required-column') {
				var insideHeight = $(this).find('.summary-toolbar').outerHeight() +
					$(this).find('.summary-content').outerHeight();
				heights.push(insideHeight);
			} else {
				var height = $(this).css('height', 'auto').outerHeight();
				heights.push(height);
			}

		});

		// Set minimum height
		heights.push(minHeight);

		// Set the new height to the tallest column.
		var newHeight = Math.max.apply(Math, heights);

		// Set the height of each column to the tallest column.
		$('#curriculog-list-column-results').height(newHeight);
		$('#curriculog-hierarchy-column-content').height(newHeight);
		$('#curriculog-dashboard-column').attr('style', 'height: ' + newHeight + 'px');
		$('#curriculog-types-column-content').height(newHeight);
		$('#curriculog-send-message-column').height(newHeight);
		$('#curriculog-summary-column').height(newHeight);
		$('#curriculog-import-required-column').height(newHeight);
	};

	/*
	 * Function: verticalStretchList
	 * Purpose: Stretches the interface down with snapping.
	 */
	objDom.verticalStretchHierarchy = function () {
		if (cui_enabled) {
			return;
		}
		var columnSelectors = [
			'#curriculog-hierarchy-column-content',
			'#curriculog-summary-column',
			'#curriculog-summary-column-content',
			'#curriculog-types-column-content'
		];
		Curriculog.util.stretch(columnSelectors);
	};

	/*
	 * Function: verticalStretchForm
	 * Purpose: Keep the left and right content columns vertically lined up.
	 * AL 11/17: Added a page option to be able to use the same vertical stretch with different column names
	 */
	objDom.verticalStretchForm = function (col1, col2, callback) {
		if (cui_enabled) {
			return;
		}
		var minHeight = 800;

		var col1Height = $(col1).css('height', 'auto').height();
		var col2Height = $(col2).css('height', 'auto').height();

		// Set the new height to the tallest column.
		var newHeight = Math.max(col1Height, col2Height, minHeight);

		$(col2).height(newHeight);
		$(col1).height(newHeight);

		// XXX This function isn't async. Why the callback?
		callback && callback();
	};

	/***
	 * summaryFlyout
	 * Purpose: expands summary data to the right to cover the dashboard.
	 * @param {JQuery} clicked - the list item that triggered flyout animation
	 * @param {Function} callback - callback function
	 *
	 ***/
	objDom.summaryFlyout = function(clicked, callback) {
		var flyoutColumn = $('#curriculog-summary-column');
		var dashboardColumn = $('#curriculog-dashboard-column');
		var leftColumn = $('#curriculog-list-column');
		var leftColumnListItems = $('.open-summary');
		var columnWrapper = $('#curriculog-columns-wrapper');
		var sendMessageColumn = $('#curriculog-send-message-column');
		var importRequiredColumn = $('#curriculog-import-required-column');
		var flyoutOpenedWidth = leftColumn.outerWidth();
		var flyoutClosedWidth = leftColumn.outerWidth() - flyoutColumn.outerWidth();
		var dashboardColumnActive = dashboardColumn.hasClass('active');
		var toggleColumnWrapper = false;

		// do not interrupt flyout if currently being animated
		if (flyoutColumn.filter(':animated').length > 0) {
			return;
		}

		if (!clicked) {
			if (dashboardColumnActive === false){
				dashboardColumn.addClass('active');
			}
			// deselect left column list items
			leftColumnListItems.removeClass('active');
			// close flyout
			flyoutColumn.animate(
				{'left': flyoutClosedWidth},
				function() {
					flyoutColumn.removeClass('active');
					flyoutColumn.children('.summary.active').removeClass('active');
					if (columnWrapper.hasClass('summary-open') && !sendMessageColumn.hasClass('active')) {
						columnWrapper.removeClass('summary-open');
					}
					Curriculog.Actions.log('flyout-closed');
					if (callback) {
						callback();
					}
				}
			);
		} else {
			// if a child element of list item was clicked, get list item
			if (clicked.hasClass('action-summary') || !clicked.hasClass('open-summary')) {
				clicked = clicked.parents('.open-summary');
			}

			// What flyout is currently open?
			var idRegex = /\d+/;
			var clickedId = clicked.attr('id').match(idRegex)[0];
			var selectedFlyoutSummary = $('#summary-' + clickedId);
			var activeFlyoutSummary = $('#summary-' + clickedId + '.active');
			var activeFlyoutSummaryId = activeFlyoutSummary.length > 0 ? activeFlyoutSummary.attr('id').match(idRegex)[0] : null;

			if (clickedId === activeFlyoutSummaryId){
				clicked.removeClass('active');
				// close flyout
				if (dashboardColumnActive === false && !sendMessageColumn.hasClass('active')) {
					dashboardColumn.addClass('active');
				}
				flyoutColumn.animate(
					{'left': flyoutClosedWidth},
					function () {
						flyoutColumn.removeClass('active');
						flyoutColumn.children('.summary.active').removeClass('active');
						if (columnWrapper.hasClass('summary-open') && !sendMessageColumn.hasClass('active')) {
							columnWrapper.removeClass('summary-open');
						}
						Curriculog.Actions.log('flyout-closed');
						if (callback) {
							callback(clickedId);
						}
					}
				);
			} else if (flyoutColumn.hasClass('active')) {
				// close flyout open new one
				$('.open-summary').removeClass('active');
				clicked.addClass('active');
				if ( dashboardColumnActive === false  && !sendMessageColumn.hasClass('active')){
					dashboardColumn.addClass('active');
				}
				flyoutColumn.animate(
					{'left': flyoutClosedWidth},
					function () {
						flyoutColumn.children('.summary.active').removeClass('active');
						selectedFlyoutSummary.addClass('active');
						if (columnWrapper.hasClass('summary-open') && !sendMessageColumn.hasClass('active')) {
							columnWrapper.removeClass('summary-open');
						}
						Curriculog.Actions.log('flyout-closed');

						flyoutColumn.animate(
							{'left': flyoutOpenedWidth},
							function () {
								if (dashboardColumnActive === true ) {
									dashboardColumn.removeClass('active');
								}
								if (cui_enabled) {
									columnWrapper.addClass('summary-open');
								}
								Curriculog.Actions.log('flyout-opened');
								if (callback) {
									callback(clickedId);
								}
							}
						);
					}
				);

			} else {
				// open new flyout
				leftColumnListItems.removeClass('active');
				clicked.addClass('active');
				selectedFlyoutSummary.addClass('active');
				flyoutColumn.addClass('active');
				if ( dashboardColumnActive === false  && !sendMessageColumn.hasClass('active')){
					dashboardColumn.addClass('active');
				}
				flyoutColumn.animate(
					{'left': flyoutOpenedWidth},
					function () {
						if (dashboardColumnActive === true){
							dashboardColumn.removeClass('active');
						}
						if (importRequiredColumn) {
							importRequiredColumn.removeClass('active');
						}
						if (cui_enabled) {
							columnWrapper.addClass('summary-open');
						}
						Curriculog.Actions.log('flyout-opened');
						if (callback) {
							callback(clickedId);
						}
					}
				);
			}
		}

		// Close the summary.
		flyoutColumn.off('click', '.close-widget').on('click', '.close-widget', function (e) {
			e.preventDefault();
			$('.open-summary').removeClass('active');
			if ( $('#curriculog-dashboard-column').hasClass('active') === false  && !sendMessageColumn.hasClass('active')){
				dashboardColumn.addClass('active');
			}
			flyoutColumn.animate(
				{'left': flyoutClosedWidth},
				function () {
					flyoutColumn.children('.summary.active').removeClass('active');
					flyoutColumn.removeClass('active');
					if (!sendMessageColumn.hasClass('active') && columnWrapper.hasClass('summary-open')) {
						columnWrapper.removeClass('summary-open');
					}
					Curriculog.Actions.log('flyout-closed');
				}
			);
		});
	};

  /***
   * adjustCUIFormToolbox
   * Adjusts the offset of AP/Proposal/Hierarchy toolbox tab to prevent user from
   * needing to scroll up to see tab contents when viewing long forms
   * params:
   * id{String} - jQuery selector representing id (sans #) of tab to be adjusted
   ***/
  objDom.adjustCUIFormToolbox = function(id) {
	$('.form-spacer').remove();
    var $tab = $('#'+id);
    $tab.removeAttr('style');
    var $summaryCol = $('#curriculog-steps-column-content');
	if ($('#curriculog-content').hasClass('approval-process-page') || $('#curriculog-content').hasClass('hierarchy-page')) {
	  	$summaryCol = $('#curriculog-steps-column-decisions');
	}

	$summaryCol.prepend('<div class="form-spacer"></div>');
	$summarySpacer = $('.form-spacer');
	var summaryColMargin = $summaryCol.offset().top;
    var cui_margin = $('#curriculog-toolbar').height();
    if ($('#curriculog-content').hasClass('admin')) {
      cui_margin += $('#curriculog-admin-header').height();
    }

    var $w = $(window);
    var viewportTop = $w.scrollTop();
    // If we are scrolled down but the summary column top is
    // still on screen, top is the summary column
    if (viewportTop > 0 && viewportTop < summaryColMargin) {
		$summarySpacer.height(0);
    // If we are scrolled down past the summary column top,
    // top is under the main menu
    } else if (viewportTop > 0) {
		$summarySpacer.height(viewportTop);
    }

    $w.off('scroll.adjustCUIFormToolbox');
    $w.on('scroll.adjustCUIFormToolbox', function() {
      var scrollPos = $w.scrollTop();
      if (scrollPos < viewportTop) {
        $summarySpacer.height(scrollPos);
      }
    });
  };

	objDom.adjustFlyout = function(id, cui_enabled) {
    	// flyout sticky glue and vertical stretch 2
		if (cui_enabled) {
			objDom.adjustFlyoutCUI(id);
			return;
		}
    	var $summary = $('#summary-' + id);
    	$('.summary.active:not(#' + $summary.attr('id') + ')').removeClass('active');
		var topNavHeight = 29;
		var summaryColMargin = $('#curriculog-summary-column').offset().top;
		var $w = $(window);
		var viewportTop = $w.scrollTop();
		// If we are scrolled down but the summary column top is
		// still on screen, top is the summary column
		if (viewportTop > 0 && viewportTop < summaryColMargin) {
        		$summary.offset({top: summaryColMargin});
		// If we are scrolled down past the summary column top,
		// top is under the main menu
		} else if (viewportTop > 0) {
			viewportTop += topNavHeight;
			$summary.offset({top:viewportTop});
		}

		$w.off('scroll.adjustFlyout');
		$w.on('scroll.adjustFlyout', function() {
			var scrollPos = $w.scrollTop(),
				flyoutTop = $('#curriculog-summary-column').offset().top;

			if (scrollPos < flyoutTop) {
				$summary.offset({top:flyoutTop});
			} else if (scrollPos < viewportTop) {
				$summary.offset({top:scrollPos + topNavHeight});
			}
		});

		var summaryHeight = $summary.css('height', 'auto').outerHeight();
		var newHeight = Math.max(viewportTop + summaryHeight, 800);
		objDom.verticalStretchList(newHeight);
		objDom.removeMask('#curriculog-summary-column');
	};

	objDom.resetFlyout = function(id) {
		$('.summary').removeAttr('style');
	};


	objDom.adjustFlyoutCUI = function(id) {
		var $window = $(window);
		var viewportTop = $window.scrollTop();
		var summaryId = '#summary-' + id;
		var $summary = $(summaryId);
		$previousSummary = $('.summary.active:not(' + summaryId + ')');
		$('.summary .spacer').remove();
		$previousSummary.removeClass('active');
		$summaryHeader = $(summaryId + ' .summary-content').first();
		var summaryHeaderMargin = $summaryHeader.offset().top;
		$summary.prepend('<div class="spacer"></div>');
		$summarySpacer = $summary.find('.spacer');
		var cui_margin = parseInt($('#curriculog-toolbar').css('height'));
		
		// If we are scrolled down but the summary column top is
		// still on screen, no spacing needed
		if ( viewportTop > 0 && viewportTop < summaryHeaderMargin) {
			$summarySpacer.height(0);
		// If we are scrolled down past the summary column top,
		// top is under the navigation menu
		} else if (viewportTop > 0) {
			$summarySpacer.height(viewportTop - cui_margin);
		}

		$window.off('scroll.adjustFlyout');
		$window.on('scroll.adjustFlyout', function() {
			var scrollPos = $(window).scrollTop();
			if (scrollPos < viewportTop)
			{
				$summarySpacer.height(scrollPos - cui_margin);
			}
		});

		objDom.removeMask('#curriculog-summary-column');
	};

	/***
	 * Function: summaryFlyoutHierarchy
	 * Purpose: expands summary data for three different types of items (entities, roles and users)
	 *	within the hierarchy page
   * @param {JQuery} clicked - the list item that triggered flyout animation
   * @param {Function} callback - callback function
	 ***/
	objDom.summaryFlyoutHierarchy = function (clickedId, callback) {
		// Set the IDs for the new and old detail and matching summary.
		var activeDetailId = '';
		try {
			activeDetailId = $('.summary.active').attr('id').match(/summary-(.*-.*)/)[1];
		} catch (e) {
			// nothing is active
		}
    var flyoutColumn = $('#curriculog-summary-column');
    var hierarchyColumn = $('#curriculog-hierarchy-column');
    var leftColumn = $('#curriculog-list-column-results-content');
    var sideMenu = $('#curriculog-side-menu');
    var columnWrapper = $('#curriculog-columns-wrapper');

    // do not interrupt flyout if currently being animated
    if (flyoutColumn.filter(':animated').length > 0) {
      return;
    }


		// Remove the highlight on the details.
		$('.open-summary').find('.item-wrapper:first').removeClass('active');
		$('#curriculog-list-column-results-content .open-summary').removeClass('active');

		// Set the open and close widths.
		var hierarchyColumnWidth = hierarchyColumn.outerWidth();
		var summaryColumnWidth =  flyoutColumn.outerWidth();
		var detailOpen = hierarchyColumnWidth + 2;
		var detailClosed = hierarchyColumnWidth - summaryColumnWidth;
    var clicked = $('#' + clickedId);

		// Decide what operation to perform.
		if (activeDetailId === clickedId) {
			// Close the summary.
			flyoutColumn.animate(
				{'left': detailClosed},
				function () {
					flyoutColumn.removeClass('active');
          flyoutColumn.children('.summary.active').removeClass('active');
          if (columnWrapper.hasClass('summary-open')) {
            columnWrapper.removeClass('summary-open');
          }
          sideMenu.addClass('active');
					Curriculog.Actions.log('hierarchy-flyout-closed');
				}
			);
		} else if (flyoutColumn.hasClass('active')) {
			// Close the old summary then open the new one.
			// hierarchy list item active
			clicked.find('.item-wrapper:first').addClass('active');
			// user list item active
			leftColumn.children('#' + clickedId).addClass('active');
			flyoutColumn.animate(
        {'left': detailClosed},
				function () {
          if (columnWrapper.hasClass('summary-open')) {
            columnWrapper.removeClass('summary-open');
          }
					Curriculog.Actions.log('hierarchy-flyout-closed');
					$('#curriculog-summary-column').animate(
						{'left': detailOpen},
						function () {
              if (cui_enabled) {
                columnWrapper.addClass('summary-open');
              }
              sideMenu.removeClass('active');
							Curriculog.Actions.log('hierarchy-flyout-opened');
						}
					);
          if (callback) {
            callback(clickedId);
          }
				}
			);
		} else {
			// Open the summary.
      if (cui_enabled) {
        columnWrapper.addClass('summary-open');
      }
			// hierarchy list item active
			clicked.find('.item-wrapper:first').addClass('active');
			// user list item active
			leftColumn.children('#' + clickedId).addClass('active');
			$('.summary').addClass('active');
			flyoutColumn.addClass('active');
			flyoutColumn.css({'left': detailClosed});
			flyoutColumn.animate(
				{'left': detailOpen},
				function () {
          sideMenu.removeClass('active');
					Curriculog.Actions.log('hierarchy-flyout-opened');
				}
			);
			if (callback) {
        callback(clickedId);
      }
		}
	};


	objDom.deactivateImageDrop = function (editor, callback) {
		editor.document.on('drop', function (e) {
			e.data.preventDefault(true);
		});

		callback && callback();
	};

	objDom.showProgress = function (id, message) {

		if (typeof message === 'undefined') {
			message = 'Saving';
		}

		var dialog = objDialog.createBasicNotification(id, 'Mesage', function (dialog, defaults) {
			defaults.width = 450;

			$(dialog).prepend('<h3>' + message + '</h3>');

			defaults.close = function (event, ui) {
				$(dialog).remove();
			};

			$(dialog).dialog(defaults);
		});

		return 'curriculog-dialog' + id;
	};

	objDom.showSuccess = function (id, message) {

		if (typeof message === 'undefined') {
			message = 'Successfully Completed';
		}

		$('#'+ id).dialog( 'option', 'buttons', [{
				text: 'Ok',
				click: function () {
					//$(this).dialog("close").remove();
					objDom.showError(id);
				}
			}])
			.html('<h3>' + message + '</h3>')
			.addClass('success');

		return id;
	};

	objDom.showError = function (id, message) {

		if (typeof message === 'undefined') {
			message = 'An Error has Occurred';
		}

		$('#'+ id).dialog('option', 'buttons', [{
				text: 'Ok',
				click: function () {
					$(this).dialog('close').remove();
				}
			}])
			.html('<h3>' + message + '</h3>')
			.addClass('error');

		return id;
	};

	/*
	 * Function: addCustomMask
	 * Purpose: adds a mask with a custom message
	 */
	objDom.addCustomMask = function (selector, msg, topPosition, leftPosition) {
		if (msg === undefined || msg === null) {
			msg = 'Saving';
		}

		$(selector).mask(msg);

		if (topPosition !== undefined && topPosition !== null) {
			$(selector + ' .loadmask-msg').css('top', topPosition + 'px');
		}

    // insure loading mask is always vertically centered.
    // left position should usually be the center of the selector
    if (leftPosition !== undefined && leftPosition !== null) {
			$(selector + ' .loadmask-msg').css({
        position: 'fixed',
        top: '50%',
        left: leftPosition,
        transform: 'translate(-50%, -50%)'
      });
		}
	};

	/*
	 * Function: addMask
	 * Purpose: adds a saving mask to the element
	 */
	objDom.addMask = function (selector) {
		$(selector).mask('Saving');
	};

	/*
	 * Function: removeMask
	 * Purpose: removes a saving mask from the element
	 */
	objDom.removeMask = function (selector) {
		$(selector).unmask();
	};

	/*
	 * Function: addMask
	 * Purpose: adds a saving mask to the element
	 */
	objDom.addLoadingMask = function (selector, delay) {
		$(selector).mask('Loading', delay);
	};

	objDom.importRequiredFlyout = function(clicked, callback) {
		var flyoutColumn = $('#curriculog-import-required-column');
		var dashboardColumn = $('#curriculog-dashboard-column');
		var leftColumn = $('#curriculog-list-column');
		var columnWrapper = $('#curriculog-columns-wrapper');
		var summaryColumn = $('#curriculog-summary-column');
		var flyoutOpenedPosition = leftColumn.outerWidth();
		var flyoutClosedPosition = leftColumn.outerWidth() - flyoutColumn.outerWidth();

		if ((flyoutColumn.hasClass('active') && !clicked) ||
			(flyoutColumn.hasClass('active') && clicked.hasClass('active')) )
		{
			// close flyout
			$('.open-summary').removeClass('active');
			dashboardColumn.addClass('active');
			flyoutColumn.animate(
				{'left': flyoutClosedPosition},
				function() {
					flyoutColumn.removeClass('active');
					if (cui_enabled) {
						columnWrapper.removeClass('summary-open');
					}
					Curriculog.Actions.log('flyout-closed');
					if (callback) {
						callback(clicked);
					}
				}
			);
		} else if (flyoutColumn.hasClass('active') && !clicked.hasClass('active')) {
			// close, then open flyout
			$('.open-summary').removeClass('active');
			dashboardColumn.addClass('active');
			flyoutColumn.animate(
				{'left': flyoutClosedPosition},
				function() {
					flyoutColumn.removeClass('active');
					if (cui_enabled) {
						columnWrapper.removeClass('summary-open');
					}
					Curriculog.Actions.log('flyout-closed');

					clicked.addClass('active');

					flyoutColumn.addClass('active');
					flyoutColumn.animate(
						{'left': flyoutOpenedPosition},
						function() {
							if (cui_enabled) {
								columnWrapper.addClass('summary-open');
							}
							dashboardColumn.removeClass('active');
							summaryColumn.removeClass('active');
							Curriculog.Actions.log('flyout-open');
							if (callback) {
								callback(clicked);
							}
						}
					);
				}
			);
		} else {
			// open flyout
			$('.open-summary').removeClass('active');
			if (clicked) {
				clicked.addClass('active');
			}
			flyoutColumn.addClass('active');
			flyoutColumn.animate(
				{'left': flyoutOpenedPosition},
				function() {
					if (cui_enabled) {
						columnWrapper.addClass('summary-open');
					}
					dashboardColumn.removeClass('active');
					summaryColumn.removeClass('active');
					Curriculog.Actions.log('flyout-open');
					if (callback) {
						callback(clicked);
					}
				}
			);
		}

		flyoutColumn.off('click', '.close-widget');
		flyoutColumn.on('click', '.close-widget', function(event) {
			event.preventDefault();
			$('.open-summary').removeClass('active');

			if (!dashboardColumn.hasClass('active')) {
				dashboardColumn.addClass('active');
			}

			flyoutColumn.animate(
				{'left': flyoutClosedPosition},
				function() {
					flyoutColumn.removeClass('active');
					if (cui_enabled) {
						columnWrapper.removeClass('summary-open');
					}

					Curriculog.Actions.log('flyout-closed');
				}
			);
		});
	};

	return objDom;
};
